import Breadcrumbs from "./breadcrumbs";
export default class Documents {
    constructor() {
        this.breadcrumbs = new Breadcrumbs('documents');
        this.breadcrumbs.get();
        this.initListeners()
    }

    initListeners() {
        // формирование роута без перезагрузки страницы
        document.querySelectorAll('.documents .nav-link').forEach((nav) => {
            nav.addEventListener('click', (e) => {
                let name = e.target?.dataset?.type;
                let pathname = window.location.pathname.split('/');
                pathname = pathname.filter(v => v.length > 0)
                let city = pathname[0] || 'petrozavodsk';
                let main = pathname[1] || 'documents';

                let refresh = window.location.origin + `/${city}/${main}/${name}/`;
                window.history.pushState({path: refresh}, '', refresh);

                document.querySelector('.js-breadcrumbs-item-last').textContent = this.breadcrumbs.get()[name] || '';
            })
        })
    }
}
